module.exports = __webpack_public_path__ + "static/media/security.6bea4f1e.png";